import randomBytes from 'randombytes';

const generateId = (len = 16): string => randomBytes(len).toString('hex');

export default generateId;
